import { useMutation } from "@tanstack/react-query";

import { handleSavePhoenixClickAttribution } from "../../api-clients/userAccountClient";
import { clearPhoenixClickId } from "../../utils/phoenix-click";
import { QUERY_KEYS } from "../constants";
import Logger from "../../utils/logger";

function useSavePhoenixClickMutation() {
  const mutation = useMutation({
    mutationKey: [QUERY_KEYS.ATTRIBUTION.SAVE_PHOENIX_CLICK],
    mutationFn: (phxClickId: string) =>
      handleSavePhoenixClickAttribution({ phxClickId }),
    onSuccess: () => {
      clearPhoenixClickId();
    },
    onError: (error) => {
      Logger.error(`Failed to save Phoenix click attribution: ${error}`);
    },
  });

  return mutation;
}

export default useSavePhoenixClickMutation;
